import React, { FC } from 'react';

import { navigate } from '@reach/router';
import moment from 'moment';

import { IEventItem } from '../../../../store/player/events/store';

import Button from '../../../../components/Button';
import { isDateUCTSameAsToday } from '../../../../Utils/isDateUCTSameAsToday';

interface IProps {
  item: IEventItem;
  onAddNote?: () => void;
  onRegister?: () => void;
  onWithdraw?: () => void;
}

const EventRegistry: FC<IProps> = props => {
  const {
    onAddNote,
    item: { id, totalPlayers, enrollment, enrollments, start, end, rounds },
    onRegister,
    onWithdraw
  } = props;

  const today = moment();
  const isOpen = today < moment(start);
  const isRunning = moment(start) <= today && today <= moment(end);
  const isClosed = moment(end) < today;
  const activePlayers = enrollments.filter(e => e.status === 'active').length;

  const currentRound = isRunning && rounds.find(r => isDateUCTSameAsToday(r.start));

  const goToRound = () =>
    currentRound ? navigate(`/event-scores/${id}/round/${currentRound.id}/set-scorer`) : null;

  return (
    <div className="event-stats">
      <Button
        className="button button-shadow"
        variant="contained"
        color={isRunning ? 'primary' : 'secondary'}
        disabled={isClosed || !currentRound}
        onClick={
          isClosed ? (onWithdraw ? onWithdraw : undefined) : isRunning ? goToRound : undefined
        }
      >
        {isClosed ? 'EVENT CLOSED' : 'GO TO ROUND'}
      </Button>

      {isOpen &&
        (enrollment && (enrollment.status === 'active' || enrollment.status === 'waiting') ? (
          <>
            <Button
              variant="contained"
              color="primary"
              className="button"
              onClick={onAddNote}
              id="success-leave-note"
            >
              ADD NOTE FOR THE EVENT DIR.
            </Button>

            <Button
              className="button button-shadow"
              variant="outlined"
              color="primary"
              onClick={onWithdraw}
            >
              WITHDRAW FROM THIS EVENT
            </Button>
          </>
        ) : (
          <Button
            className="button button-shadow"
            variant="contained"
            color="primary"
            onClick={onRegister}
          >
            {totalPlayers - activePlayers <= 0 ? 'JOIN WAITING LIST' : 'REGISTER FOR THIS EVENT'}
          </Button>
        ))}
    </div>
  );
};

export { EventRegistry };
